import { render, staticRenderFns } from "./PerformanceRevenue.vue?vue&type=template&id=40c8f3dc&scoped=true"
import script from "./PerformanceRevenue.vue?vue&type=script&lang=js"
export * from "./PerformanceRevenue.vue?vue&type=script&lang=js"
import style0 from "./PerformanceRevenue.vue?vue&type=style&index=0&id=40c8f3dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c8f3dc",
  null
  
)

export default component.exports